<template>
  <div>
    <div id="topNav">
      <div class="nav">
        <img src="@/assets/logo1.png" style="width: 120px;cursor: pointer; margin: 10px 60px 0 10px" @click="jumpHome"/>
        <!-- <svg class="icon" style="font-size: 120px; cursor: pointer; margin: 0 60px 0 30px" aria-hidden="true"
          @click="jumpHome">
          <use xlink:href="#icon-liangkuLOGO"></use>
        </svg> -->
        <el-menu :default-active="activeIndex" class="el-menu" mode="horizontal" active-text-color="#fff" :router="true"
          @select="handleSelect">
          <template v-for="item in topNav">
            <el-menu-item :key="item.name == 'oldSystem' ? item.path : item.name"
              v-if="(item.name != 'Cockpit' && item.name != 'System') && arrayInclude(permission, [item.name])"
              :index="item.name == 'oldSystem' ? '' : item.path">{{ item.text }}
            </el-menu-item>
          </template>
        </el-menu>
      </div>
      <div class="navLeft">
        <a @click="setMainNav('/cockpit')" title="驾驶舱">
          <i class="el-icon-monitor" v-if="arrayInclude(permission, ['Cockpit'])"></i>
        </a>
        <a @click="setMainNav('/worktable')" title="工作台">
          <template v-if="arrayInclude(permission, ['WorkTable'])">
            <el-badge is-dot class="item" v-if="MessageState">
              <i class="el-icon-bell"></i>
            </el-badge>
            <i class="el-icon-bell" v-else></i>
          </template>
        </a>
        <a @click="setMainNav('/system')" title="系统管理">
          <i class="el-icon-setting" v-if="arrayInclude(permission, ['System'])"></i>
        </a>
        <el-dropdown @command="handleCommand">
          <div class="userInfo el-dropdown-link">
            <img :src="showavatarUrl" style="border-radius:50%;" />
            <span class="username" style="width: 60px;text-align: center;">{{ username }}</span>
            <i class="el-icon-arrow-down el-icon--right"></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item icon="el-icon-user" command="information">个人信息</el-dropdown-item>
            <el-dropdown-item icon="el-icon-lock" command="gopassword">修改密码</el-dropdown-item>
            <el-dropdown-item icon="el-icon-monitor" divided command="goHome">返回首页</el-dropdown-item>
            <el-dropdown-item icon="el-icon-switch-button" command="goLogin">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <password v-if="tankindex == 1" @showidemit="tankindex = 0"></password>
    <userinfo v-if="tankindex == 2" @showidemit="tankindex = 0" ref="userinfo"></userinfo>
  </div>
</template>
<script>
import { httpToken } from "@/utils/http";
import { sortNum, arrayInclude } from "@/utils/util";
import Config from "@/utils/config";
import password from "@/components/Dialog/password.vue";
import userinfo from "@/components/Dialog/userinfo.vue";
import { imgshow2 } from "@/api/file";
export default {
  name: "TopNav",
  components: { password, userinfo },
  data() {
    return {
      arrayInclude: arrayInclude,
      activeIndex: "/" + this.$store.state.mainNav.toLowerCase(),
      topNav: Config.topNav.sort(sortNum),
      //  修改密码弹框状态  1为修改密码开启 2为修改用户 0为关闭
      tankindex: 0,
      // 工作台消息状态
      MessageState: false,
      Config: Config,
      showavatarUrl: require('@/assets/images/headimg.png'),
      permission: JSON.parse(sessionStorage.getItem("permission"))
    };
  },
  mounted() {
    this.getagency();
    if (JSON.parse(sessionStorage.user).avatarUrl) {
      return imgshow2(JSON.parse(sessionStorage.user).avatarUrl).then(res => {
        if (res.data.code === 200)
          this.showavatarUrl = "data:image/jpeg;base64," + res.data.data
      })
    }
  },
  computed: {
    username: function () {
      return JSON.parse(sessionStorage.user).chnname
    },
  },
  methods: {
    // 获取用户代办事项数据
    getagency() {
      if (arrayInclude(this.permission, ['WorkTable']))
        httpToken({
          method: "post",
          url: "/workbench/agency",
        }).then((res) => {
          if (res.data.data.count > 0) {
            this.MessageState = true;
          }
        });
    },
    handleSelect() { },
    handleCommand(command) {
      if (command === "information") {
        this.tankindex = 2;
        this.$nextTick(() => {
          this.$refs.userinfo.getjson(JSON.parse(sessionStorage.user))
        })
      }
      if (command === "goHome") {
        this.jumpHome();
      }
      if (command === "goLogin") {
        this.Logout();
      }
      if (command == "gopassword") {
        this.tankindex = 1;
      }
    },
    setMainNav(e) {
      this.$router.push({ path: e });
    },
    jumpHome() {
      this.$router.push({ path: "/" });
    },
    Logout() {
      let _this = this;
      this.$confirm("是否确认退出系统", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        httpToken({
          url: "/shiro/logout",
          method: "post",
        }).then((res) => {
          if (res.data.code == 200) {
            sessionStorage.removeItem("token");
            sessionStorage.removeItem("user");
            this.$message({
              type: "success",
              duration: 1000,
              message: "退出成功!",
            });
            window.setdocumentTitle(false)
            setTimeout(() => {
              _this.$router.push({ path: "/login" });
            }, 1000);
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
#topNav {
  width: 100%;
  height: 66px;
  line-height: 66px;
  // box-shadow: 0 3px 7px rgba(127, 152, 179, 0.35);
  box-shadow: 0 3px 3px #2557db;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 30px;
  box-sizing: border-box;
  position: relative;
  background-color: #2557db;
  z-index: 9;

  .nav {
    height: 66px;
    display: flex;
    align-items: center;

    .logo_lk {
      width: 101px;
      height: 35px;
      padding: 0 67px 0 37px;
      cursor: pointer;
    }

    .el-menu.el-menu--horizontal {
      display: flex;
      border-bottom: none;
      background-color: #2557db;

      .el-menu-item {
        height: 100%;
        line-height: 64px;
        font-size: 18px;
        padding: 0 15px;
        margin: 0 15px;
        color: #fff;
        background-color: #2557db;
        border-bottom: 2px solid rgba(255, 255, 255, 0);
      }

      .el-menu-item:hover {
        background-color: #376bf4;
      }
    }
  }

  .navLeft {
    width: 220px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    font-size: 18px;

    ::v-deep i {
      font-size: 16px;
      cursor: pointer;
    }

    ::v-deep .el-badge__content.is-fixed.is-dot {
      top: 25px;
      right: 25px;
    }

    i {
      margin-right: 20px;
      cursor: pointer;
      font-size: 24px;
      color: #fff;
    }

    .userInfo {
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: space-around;
      color: #fff;

      .username {
        line-height: 20px;
      }

      img {
        width: 28px;
        height: 28px;
        margin-right: 10px;
        margin-left: 20px;
      }

      ::v-deep i {
        font-size: 16px;
      }
    }
  }
}

.icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
</style>
